import { ComponentType } from "react"

export function withHooksToProps<P>(Comp: ComponentType<P>, useHooksToProps: (p: Partial<P>) => Partial<P>) {
    return function WithHooksToProps(props: P) {
        return <Comp {...props} {...useHooksToProps(props)} />
    }
}
